module.exports = __webpack_public_path__ + "img/warioware.98d93df9.png";